import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import styled from 'styled-components';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Divider from '@material-ui/core/Divider';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import RecipientTab from './RecipientTab';
import ProductsTab from './ProductsTab';
import PackageInformationsTab from './PackageInformationsTab';
import Tracking from './TrackingTab';

import { closeDrawer } from '../../commandsActions';
import DrawerLoader from '../../utils/DrawerLoader';
import CommandDrawerTitle from '../../../CommandDrawerTitle';

const CustomTab = styled(Tab)`
  font-size: 0.8em;
  min-width: 20px;
`;

const useStyles = makeStyles(() => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  }
}));

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > div': {
      width: '100%',
      backgroundColor: '#5ccaf4'
    }
  }
})(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

/**
 * Drawer permettant d'afficher et de mettre à jour les informations des commandes
 * dans la section Expéditions
 *
 * @param {Boolean}  isOpen              Status du drawer ouver ou fermer
 * @param {Function} dispatchCloseDrawer Function permettant de fermer le drawer
 * @param {Object}   currentCommand      Object representer la commande afficher dans le drawer
 * @param {Boolean}  loading             Indiquer si la rêquete est en cours
 */
const NotSentDrawer = ({ isOpen, dispatchCloseDrawer, loading }) => {
  const classes = useStyles();
  const [width] = useState(40);
  const [currentTable, setCurrentTable] = useState(0);

  function handleChange(event, newValue) {
    setCurrentTable(newValue);
  }

  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        dispatchCloseDrawer();
        setCurrentTable(0);
      }}
      open={isOpen}
    >
      {loading ? (
        <DrawerLoader />
      ) : (
        <div style={{ marginLeft: 20, marginRight: 20 }}>
          <CommandDrawerTitle />
          <StyledTabs
            width={width}
            value={currentTable}
            onChange={handleChange}
            indicatorColor="primary"
          >
            <CustomTab label="Destinataire" />
            <CustomTab label="Produits" />
            <CustomTab label="Info colis" />
            <CustomTab label="Suivi" />
          </StyledTabs>
          <Divider style={{ position: 'relative', bottom: 2 }} />
          {currentTable === 0 && <RecipientTab />}
          {currentTable === 1 && <ProductsTab />}
          {currentTable === 2 && <PackageInformationsTab />}
          {currentTable === 3 && <Tracking />}
        </div>
      )}
    </SwipeableDrawer>
  );
};

const mapStateToProps = state => ({
  isOpen: state.commands.openDrawer,
  loading: state.commands.loadingCurrentCommand
});

const mapDispatchToProps = dispatch => ({
  dispatchCloseDrawer: () => dispatch(closeDrawer())
});

NotSentDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dispatchCloseDrawer: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(NotSentDrawer);
